import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when there is a gap between two intervals.
 *
 * @param {string} spec.leftInterval - string representation of left boundary of gap
 * @param {string} spec.rightInterval - string representation of right boundary of gap
 */
export default class GapFoundValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor(spec) {
		super(spec);

		this._leftInterval = spec.leftInterval;
		this._rightInterval = spec.rightInterval;
	}

	getLeftInterval() {
		return this._leftInterval;
	}

	getRightInterval() {
		return this._rightInterval;
	}

	getMessage() {
		return _('Gap between "{leftInterval}" and "{rightInterval}"', {
			leftInterval: this._leftInterval,
			rightInterval: this._rightInterval,
		});
	}

	static getType() {
		return "GapFoundValidationResult";
	}
}
